import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const NavGroup = ({ children, isGroupSelected, name, id }) => {
  return (
    <div className={styles['nav-group']}>
      <input type="checkbox" id={id} className="nav-link" defaultChecked={isGroupSelected} />
      <label htmlFor={id}>{name}</label>
      <ul>
        {children}
      </ul>
    </div>
  );
};

NavGroup.propTypes = {
  children: PropTypes.node.isRequired,
  isGroupSelected: PropTypes.bool,
  name: PropTypes.node.isRequired,
};

NavGroup.defaultProps = {
  isGroupSelected: false,
};

export default NavGroup;
